import { Ship } from "./ship";

export class ShipDetail {
    id?: string;
    ship?: Ship;
    isCreationMode?: boolean;
    isEditMode?: boolean;
    isReadOnlyMode?: boolean;
    constructor(shipDetail?: ShipDetail) {
        this.id = shipDetail?.id;
        this.ship = shipDetail?.ship;
        this.isCreationMode = shipDetail?.isCreationMode || false;
        this.isEditMode = shipDetail?.isEditMode || false;
        this.isReadOnlyMode = shipDetail?.isReadOnlyMode || false;
    }
}
